export function extractYouTubeVideoId(
  youtubeUrl: string | undefined,
): string | null {
  if (!youtubeUrl) {
    return null
  }

  const normalized = youtubeUrl.trim()
  if (!normalized) {
    return null
  }

  try {
    const parsedUrl = new URL(normalized)
    const hostname = parsedUrl.hostname.toLowerCase()

    if (hostname === 'youtu.be') {
      const idFromPath = parsedUrl.pathname.replace('/', '').trim()
      return idFromPath.length > 0 ? idFromPath : null
    }

    if (hostname.includes('youtube.com')) {
      const idFromQuery = parsedUrl.searchParams.get('v')?.trim()
      if (idFromQuery) {
        return idFromQuery
      }

      const pathParts = parsedUrl.pathname.split('/').filter(Boolean)
      const embedIndex = pathParts.findIndex((part) => part === 'embed')
      if (embedIndex >= 0 && pathParts[embedIndex + 1]) {
        return pathParts[embedIndex + 1]
      }

      const shortsIndex = pathParts.findIndex((part) => part === 'shorts')
      if (shortsIndex >= 0 && pathParts[shortsIndex + 1]) {
        return pathParts[shortsIndex + 1]
      }

      const liveIndex = pathParts.findIndex((part) => part === 'live')
      if (liveIndex >= 0 && pathParts[liveIndex + 1]) {
        return pathParts[liveIndex + 1]
      }
    }
  } catch {
    return null
  }

  return null
}

export function isYouTubeShortUrl(youtubeUrl: string | undefined): boolean {
  if (!youtubeUrl) {
    return false
  }

  const normalized = youtubeUrl.trim()
  if (!normalized) {
    return false
  }

  try {
    const parsedUrl = new URL(normalized)
    const hostname = parsedUrl.hostname.toLowerCase()
    if (!hostname.includes('youtube.com')) {
      return false
    }

    const pathParts = parsedUrl.pathname
      .split('/')
      .filter(Boolean)
      .map((part) => part.toLowerCase())

    return pathParts.includes('shorts')
  } catch {
    return false
  }
}

export function buildCanonicalYouTubeUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`
}
